/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { TextField, SingleSelectDropDown } from '@insticator/insticator-ui';
import injectSheet from "react-jss"; // iui-material
// utils

//styles
import styles from 'material/embeds/cardplacement/cardplacement_styles';


/* ========== ~~~~~~~~~~ MATERIAL : CARD PLACEMENT ~~~~~~~~~~ ========== */
const CardPlacement = (props) => {

    const controlPosition = position => {
        if(position > props.numberOfContents + 1){
            return Number(props.numberOfContents) + 1
        }
        return position ? Number(position) : position;
    };

    return(
        <div className={`cardplacement ${props.classes.cardplacement}`}>
            Add card to position:
            <TextField
                value={props.value}
                type={'number'}
                searchable={false}
                handleChange={placement => props.handleChange(controlPosition(placement.target.value))}
                />
        </div>
    );
};

// const CardPlacement = (props) => {
//
//     const dropdownValues = [{value: 'LAST', name: 'last'}, {value: 'FIRST', name: 'first'}];
//     const selected = {value: props.selected, name: props.selected.toLowerCase()};
//
//     return(
//         <div className={`cardplacement ${props.classes.cardplacement}`}>
//             Place new card:
//             <SingleSelectDropDown
//                 selected={selected}
//                 items={dropdownValues}
//                 searchable={false}
//                 onSelect={placement => props.onSelect(placement.value)}
//             />
//         </div>
//     );
// };



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CardPlacement);
